import { apiClient, createSuccessResponse, handleApiError } from "./api";

const configurationService = {

    async editConfiguration(id) {
        try {

            console.log(id)

            var retorno = await apiClient.get("/configuration/" + id);
            console.log(retorno.data)
            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },
    
    async create(configuration) {
        try {
            console.log(configuration)

            var retorno = await apiClient.post("/configuration", configuration);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async list() {
        try {
            console.log("list")

            var retorno = await apiClient.get("/configuration");
            console.log("📡 [configurationService] Resposta da API:", retorno.data);

            // Se a API retorna { data: [...], pagination: {...} }
            if (retorno.data && retorno.data.data && retorno.data.pagination) {
                return {
                    success: true,
                    status: retorno.status,
                    data: retorno.data.data,
                    pagination: retorno.data.pagination
                };
            }
            // Se a API retorna apenas um array
            else if (Array.isArray(retorno.data)) {
                return {
                    success: true,
                    status: retorno.status,
                    data: retorno.data,
                    pagination: {
                        currentPage: 1,
                        totalPages: 1,
                        totalItems: retorno.data.length,
                        itemsPerPage: 10,
                        hasNext: false,
                        hasPrev: false,
                    }
                };
            }
            // Fallback para createSuccessResponse
            else {
                return createSuccessResponse(retorno.data, retorno.status, retorno.message);
            }
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async update(configuration) {
        try {
            console.log(configuration)

            var retorno = await apiClient.put("/configuration", configuration);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async delete(id) {
        try {
            var retorno = await apiClient.delete("/configuration/" + id);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

}

export default configurationService;